import { render, staticRenderFns } from "./PostCodeTypeahead.vue?vue&type=template&id=f0a38b04&scoped=true"
import script from "./PostCodeTypeahead.vue?vue&type=script&lang=js"
export * from "./PostCodeTypeahead.vue?vue&type=script&lang=js"
import style0 from "./PostCodeTypeahead.vue?vue&type=style&index=0&id=f0a38b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a38b04",
  null
  
)

export default component.exports